<template>
  <div>
    <h3>创建班级内容</h3>
    <el-form @submit.native.prevent="savePrice">
      <el-form-item label="所属网校">
        <el-select v-model="model.maID" placeholder="网校">
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="所属级别">
        <el-select
          v-model="model.chID"
          multiple
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属级别">
        <el-select
          v-model="model.coID"
          @change="getClass"
          multiple
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所属级别">
        <el-select v-model="model.clID" multiple placeholder="三级分类">
          <el-option
            v-for="item in clclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-card>
        <div>
          <p>添加视频课程</p>
          <div
            v-for="(item, index) in prvideo"
            :key="item.id"
            style="display: flex"
          >
            <el-input
              v-model="item.prVideoName"
              class="el-input"
              style="padding-bottom: 5px"
            ></el-input
            ><el-button
              @click="delVideoInput(index)"
              type="text"
              icon="el-icon-delete"
              circle
            ></el-button>
          </div>

          <el-button @click="addVideoInput">新增一行</el-button>
        </div>
      </el-card>
      <el-card style="margin-top: 15px">
        <div>
          <p>添加电子资料</p>
          <div
            v-for="(item, index) in prpdf"
            :key="item.id"
            style="display: flex"
          >
            <el-input
              v-model="item.prPdfName"
              class="el-input"
              style="padding-bottom: 5px"
            ></el-input
            ><el-button
              @click="delPdfInput(index)"
              type="text"
              icon="el-icon-delete"
              circle
            ></el-button>
          </div>

          <el-button @click="addPdfInput">新增一行</el-button>
        </div>
      </el-card>

      <el-card style="margin-top: 15px">
        <div>
          <p>添加教学服务</p>
          <div
            v-for="(item, index) in prservice"
            :key="item.id"
            style="display: flex"
          >
            <el-input
              v-model="item.prServiceName"
              class="el-input"
              style="padding-bottom: 5px"
            ></el-input
            ><el-button
              @click="delServiceInput(index)"
              type="text"
              icon="el-icon-delete"
              circle
            ></el-button>
          </div>

          <el-button @click="addServiceInput">新增一行</el-button>
        </div>
      </el-card>

      <el-card style="margin-top: 15px">
        <div>
          <p>添加学习期限</p>
          <div
            v-for="(item, index) in prteachtime"
            :key="item.id"
            style="display: flex"
          >
            <el-input
              v-model="item.prTeachTimeName"
              class="el-input"
              style="padding-bottom: 5px"
            ></el-input
            ><el-button
              @click="delTeachTime(index)"
              type="text"
              icon="el-icon-delete"
              circle
            ></el-button>
          </div>

          <el-button @click="addTeachTime">新增一行</el-button>
        </div>
      </el-card>

      <el-card style="margin-top: 15px">
        <div>
          <p>添加学习方式</p>
          <div
            v-for="(item, index) in prteachway"
            :key="item.id"
            style="display: flex"
          >
            <el-input
              v-model="item.prTeachWayName"
              class="el-input"
              style="padding-bottom: 5px"
            ></el-input
            ><el-button
              @click="delPrTeachWay(index)"
              type="text"
              icon="el-icon-delete"
              circle
            ></el-button>
          </div>

          <el-button @click="addPrTeachWay">新增一行</el-button>
        </div>
      </el-card>
      <el-form-item style="margin-top: 15px">
        <el-button type="primary" native-type="submit">点击创建</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      priceLength: 0,
      activeName: "first",
      major: [],
      channel: [],
      course: [],
      price: [],
      clclass: [],
      model: {},
      prvideo: [{ prVideoId: Date.now(), prVideoName: "" }],
      prpdf: [{ prPdfId: Date.now(), prPdfName: "" }],
      prservice: [{ prServiceId: Date.now(), prServiceName: "" }],
      prteachway: [{ prTeachWayId: Date.now(), prTeachWayName: "" }],
      prteachtime: [{ prTeachTimeId: Date.now(), prTeachTimeName: "" }],
    };
  },

  methods: {
    async savePrice() {
      try {
        const price = {
          prvideo: this.prvideo,
          prpdf: this.prpdf,
          prservice: this.prservice,
          prteachway: this.prteachway,
          prteachtime: this.prteachtime,
          chID: this.model.chID,
          maID: this.model.maID,
          coID: this.model.coID,
          clID: this.model.clID,
        };
        const createPrice = await this.$http.post(
          "/category/createprice",
          price
        );
        if (createPrice.status == 200) {
          this.$message({
            type: "success",
            message: createPrice.data.msg,
          });
          this.$router.push("/price/list");
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },

    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.clclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },
    // 动态添加视频班次
    addVideoInput(index) {
      try {
        this.prvideo.push({ prVideoId: Date.now(), prVideoName: "" });
      } catch (error) {
        console.log(error);
      }
    },
    // 删除视频班次
    delVideoInput(index) {
      try {
        this.prvideo.splice(index, 1);
      } catch (error) {
        console.log(error);
      }
    },
    // 动态添加电子资料
    addPdfInput(index) {
      try {
        this.prpdf.push({ prPdfId: Date.now(), prPdfName: "" });
      } catch (error) {
        console.log(error);
      }
    },
    // 删除电子资料
    delPdfInput(index) {
      try {
        this.prpdf.splice(index, 1);
      } catch (error) {
        console.log(error);
      }
    },
    // 动态添加教学服务
    addServiceInput(index) {
      try {
        this.prservice.push({ prServiceId: Date.now(), prServiceName: "" });
      } catch (error) {
        console.log(error);
      }
    },
    // 删除教学服务
    delServiceInput(index) {
      try {
        this.prservice.splice(index, 1);
      } catch (error) {
        console.log(error);
      }
    },
    // 动态添加学习方式
    addPrTeachWay(index) {
      try {
        this.prteachway.push({ prTeachWayId: Date.now(), prTeachWayName: "" });
      } catch (error) {
        console.log(error);
      }
    },
    // 删除教学服务
    delPrTeachWay(index) {
      try {
        this.prteachway.splice(index, 1);
      } catch (error) {
        console.log(error);
      }
    },
    // 动态添加学习方式
    addTeachTime(index) {
      try {
        this.prteachtime.push({
          prTeachTimeId: Date.now(),
          prTeachTimeName: "",
        });
      } catch (error) {
        console.log(error);
      }
    },
    // 删除教学服务
    delTeachTime(index) {
      this.prteachtime.splice(index, 1);
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    //this.getprice();
    //this.getgrade();
  },
};
</script>
